var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[(_vm.hasImage)?_c('div',{staticClass:"image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"shows-column",class:{ 'full-width': !_vm.hasImage }},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }